<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  [attr.stroke-width]="weight"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
>
  @for (d of paths; track d) {
    <path [attr.d]="d" />
  }
</svg>
